import React from "react";
import { CustomSectionComp } from "../../components/custom-section/custom-section";
import BannersComponents from "../../components/home/BannersComponents";
import MainCarousel from "../../components/home/MainCarousel";

export default function CustomSection(props) {
  const defaultOnly =
    props.location.pathname.includes("Default") &&
    !props.location.pathname.includes("Html");
  const defaultHmtl = props.location.pathname.includes("DefaultHtml");
  const custom = props.location.pathname.includes("Custom");

  return (
    <div>
      {(!defaultOnly || defaultHmtl || custom) && (
        <CustomSectionComp
          id={props?.match?.params?.id}
          title={props?.match?.params?.title}
        />
      )}
      <MainCarousel
        defaultB={props?.match?.params?.title === "Default"}
        id={props?.match?.params?.id}
        defaultOnly={defaultOnly}
      />
      {!defaultHmtl && <BannersComponents/>}
    </div>
  );
}
